<template>
  <div>
    <el-dialog title="发送邮件" center width="750px" :visible.sync="visible" @closed="onClosed"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="form" :model="form" label-width="160px" size="mini">
        <el-form-item label="标题和正文：">
          <MailTemplate ref="mailTemplate" :languageTemplates="form.mailTemplate.languageTemplates"
            :readonly="isUsingExistedMailTemplate" style="width: 500px"></MailTemplate>
        </el-form-item>

        <el-form-item label="指定收件人：">
          <div style="display: flex; flex-direction: column; gap: 10px;">
            <div>
              <el-radio-group v-model="form.activeReceiversSelectorTabName">
                <el-radio label="byConditions">根据条件</el-radio>
                <el-radio label="byUids">根据uid</el-radio>
                <el-radio label="byTids">根据tid</el-radio>
              </el-radio-group>
            </div>
            <div>
              <div v-if="form.activeReceiversSelectorTabName == 'byConditions'" style="display: flex; flex-direction: column; gap: 10px;">
                <div style="display: flex; align-items: center;">
                  <span>目标分区：</span>
                  <zone-selector placeholder="请选择" enableFullZones @ready="onZoneSelectorReady"
                    @change="onZoneSelectorChange" ref="zoneSelector">
                  </zone-selector>                  
                </div>
                <div style="display: flex; align-items: center;">
                  <span>目标渠道：</span>
                  <channel-selector placeholder="请选择" enableFullChannels @ready="onChannelSelectorReady"
                    @change="onChannelSelectorChange" ref="channelSelector">
                  </channel-selector>                  
                </div>
              </div>
              <div v-else-if="form.activeReceiversSelectorTabName == 'byUids'">
                <el-input type="textarea" rows="5" v-model="form.uidList" placeholder="可放多个uid，每行放1个"
                  style="width: 300px"></el-input>
              </div>
              <div v-else-if="form.activeReceiversSelectorTabName == 'byTids'">
                <el-input type="textarea" rows="5" v-model="form.tidList" placeholder="可放多个tid，每行放1个"
                  style="width: 300px"></el-input>
              </div>              
            </div>
          </div>
        </el-form-item>

        <el-form-item label="附件：">
          <MailAttachmentListBuilder ref="mailAttachmentListBuilder">
          </MailAttachmentListBuilder>
        </el-form-item>

        <el-form-item label="定时发送：">
          <el-switch v-model="form.isSchedledMail" active-color="#13ce66">
          </el-switch>
        </el-form-item>
        <div v-if="form.isSchedledMail">
          <div v-if="isShowSatrtAndEndAt">
            <el-form-item label="开始定时：" prop="startAt">
              <el-date-picker v-model="form.startAt" type="datetime" :clearable="false" placeholder="选择日期"
                format="yyyy-MM-dd HH:mm" value-format="timestamp">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束定时：" prop="endAt">
              <el-date-picker v-model="form.endAt" type="datetime" :clearable="false" placeholder="选择日期"
                format="yyyy-MM-dd HH:mm" value-format="timestamp">
              </el-date-picker>
            </el-form-item>
          </div>
          <el-form-item label="定时时间类型：" prop="cycleType">
            <el-select style="width: 100px" @change="cycleTypeChange" v-model="form.cycleType" placeholder="请选择">
              <el-option v-for="item in cycleTypeSelector" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="定时时间：" prop="cycle">
            <div v-if="form.cycleType == 0">
              <el-date-picker v-model="form.scheduledSendAt" type="datetime" :clearable="false" placeholder="选择日期"
                format="yyyy-MM-dd HH:mm:ss" value-format="timestamp">
              </el-date-picker>
            </div>
            <div v-else-if="form.cycleType == 1">
              <el-select style="width: 100px" v-model="cycleForm.cycle1" placeholder="几点">
                <el-option v-for="item in 24" :key="item + $util.uuid()" :label="`${item - 1}点`" :value="item - 1">
                </el-option>
              </el-select>
              <el-select style="width: 120px; margin-left: 3px" v-model="cycleForm.cycle1_1" placeholder="几分">
                <el-option v-for="item in 60" :key="item + $util.uuid()" :label="`${item - 1}分`" :value="item - 1">
                </el-option>
              </el-select>
            </div>
            <div v-else-if="form.cycleType == 2">
              <el-select style="width: 100px" v-model="cycleForm.cycle2" placeholder="周几">
                <el-option v-for="item in weekDay" :key="item.value + $util.uuid()" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
              <el-select style="width: 100px; margin-left: 3px" v-model="cycleForm.cycle2_1" placeholder="几点">
                <el-option v-for="item in 24" :key="item + $util.uuid()" :label="`${item - 1}点`" :value="item - 1">
                </el-option>
              </el-select>
              <el-select style="width: 100px; margin-left: 3px" v-model="cycleForm.cycle2_2" placeholder="几分">
                <el-option v-for="item in 60" :key="item + $util.uuid()" :label="`${item - 1}分`" :value="item - 1">
                </el-option>
              </el-select>
            </div>
            <div v-else-if="form.cycleType == 3">
              <el-select style="width: 100px" v-model="cycleForm.cycle3" placeholder="几号">
                <el-option v-for="item in 31" :key="item + $util.uuid()" :label="`${item}号`" :value="item">
                </el-option>
              </el-select>
              <el-select style="width: 100px; margin-left: 3px" v-model="cycleForm.cycle3_1" placeholder="几点">
                <el-option v-for="item in 24" :key="item + $util.uuid()" :label="`${item - 1}点`" :value="item - 1">
                </el-option>
              </el-select>
              <el-select style="width: 100px; margin-left: 3px" v-model="cycleForm.cycle3_2" placeholder="几分">
                <el-option v-for="item in 60" :key="item + $util.uuid()" :label="`${item - 1}分`" :value="item - 1">
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </div>

        <div v-if="this.$bizutil.isAuditedWithOperation()">
          <el-form-item label="备注：">
            <el-input type="textarea" rows="5" v-model="form.remark" placeholder="描述为什么发送这封邮件"
              style="width: 300px"></el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false" style="margin-right: 10px">取消</el-button>
        <span v-if="this.$bizutil.isAuditedWithOperation()">
          <el-button type="primary" :icon="form.isSchedledMail
            ? 'el-icon-alarm-clock'
            : 'el-icon-alarm-promotion'
            " @click="submit()">{{ form.isSchedledMail ? "申请定时发送" : "申请发送" }}</el-button>
          <el-tooltip effect="dark" placement="top" style="margin-left: 10px">
            <div slot="content">
              申请后待审核通过将会自动发送（或定时发送），您可以在企业投票页面看到您的申请进度。<br />如果没有合适的审批者，该申请将自动通过。
            </div>
            <span><i class="el-icon-question" style="font-size: 1.5em"></i></span>
          </el-tooltip>
        </span>
        <span v-else>
          <el-button type="primary" v-if="form.isSchedledMail" icon="el-icon-alarm-clock"
            @click="submit()">定时发送</el-button>
          <el-button type="primary" v-else icon="el-icon-s-promotion" @click="submit()">立即发送</el-button>
        </span>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const luxon = require("luxon");

import MailTemplate from "@/pages/mail/components/MailTemplate";
import MailAttachmentListBuilder from "@/pages/mail/components/MailAttachmentListBuilder";
import MailAttachment from "@/pages/mail/components/MailAttachment";
import ChannelSelector from "@/components/ChannelSelector";
import ZoneSelector from "@/components/ZoneSelector";

export default {
  data() {
    return {
      visible: true,
      form: {
        mailTemplate: null,
        activeReceiversSelectorTabName: "byConditions",
        selectedZoneId: "",
        selectedChannelId: "",
        isSchedledMail: false,
        scheduledSendAt: luxon.DateTime.now().plus({ months: 1 }).startOf("day").toMillis(),
        uidList: "",
        tidList: "",
        attachments: [],
        cycleType: 0,
        cycle: 0,
        startAt: new Date().setHours(0, 0, 0, 0),
        endAt: new Date(
          new Date().setFullYear(
            new Date().getFullYear() + 10,
            new Date().getMonth(),
            new Date().getDate()
          )
        ).setHours(0, 0, 0, 0),
        remark: "",
      },
      userRole: "",
      requestId: "",
      isShowSatrtAndEndAt: false,
      cycleForm: {
        cycle1: 0,
        cycle1_1: 0,
        cycle2: 1,
        cycle2_1: 0,
        cycle2_2: 0,
        cycle3: 1,
        cycle3_1: 0,
        cycle3_2: 0,
      },
      cycleTypeSelector: [
        {
          value: 0,
          label: "单次",
        },
        {
          value: 1,
          label: "每天",
        },
        {
          value: 2,
          label: "每周",
        },
        {
          value: 3,
          label: "每月",
        },
      ],
      weekDay: [
        {
          value: 1,
          label: "周一",
        },
        {
          value: 2,
          label: "周二",
        },
        {
          value: 3,
          label: "周三",
        },
        {
          value: 4,
          label: "周四",
        },
        {
          value: 5,
          label: "周五",
        },
        {
          value: 6,
          label: "周六",
        },
        {
          value: 7,
          label: "周日",
        },
      ],
    };
  },

  props: {
    value: Object,
  },

  computed: {
    isUsingExistedMailTemplate() {
      return !!this.value.mailTemplate;
    }
  },

  components: {
    MailTemplate,
    MailAttachmentListBuilder,
    MailAttachment,
    ChannelSelector,
    ZoneSelector,
  },

  async created() {
    bizutil.getLoginUser();
    // 给requestId赋值
    this.requestId = `admin-request-${util.uuid()}`;

    // 当前用户的角色
    {
      let loginUser = this.$bizutil.getLoginUser();
      if (loginUser) {
        this.userRole = loginUser.role;
      }
    }

    if (this.value.mailTemplate) {
      this.form.mailTemplate = {
        languageTemplates: this.value.mailTemplate.languageTemplates,
      };
    } else {
      this.form.mailTemplate = {
        languageTemplates: [],
      };
    }
  },

  methods: {
    async onChannelSelectorReady() {
      this.$refs.channelSelector.channelId = this.form.selectedChannelId;
    },

    async onChannelSelectorChange(newChannelId, oldChannelId) {
      this.form.selectedChannelId = newChannelId;
    },

    async onZoneSelectorReady() {
      this.$refs.zoneSelector.zoneId = this.form.selectedZoneId;
    },

    async onZoneSelectorChange(newZoneId, oldZoneId) {
      this.form.selectedZoneId = newZoneId;
    },

    /**
     * 提交表单
     */
    async submit() {
      let selectedZoneId = 0;
      let selectedChannelId = 0;

      // 取得邮件模板
      let mailTemplate = {};
      {
        let getDataResult = this.$refs.mailTemplate.getData();
        if (getDataResult.errorMessage) {
          this.$message({
            message: getDataResult.errorMessage,
            type: "error",
          });
          return;
        }

        mailTemplate = {
          languageTemplates: getDataResult.data.languageTemplates,
        }
      }

      // 取得附件集合
      let attachments = [];
      {
        let getDataResult = this.$refs.mailAttachmentListBuilder.getData();
        if (getDataResult.errorMessage) {
          this.$message({
            message: getDataResult.errorMessage,
            type: "error",
          });
          return;
        }

        attachments = getDataResult.data.attachments;
      }

      let mailTemplateId = "0";
      let mailLanguageTemplates = null;
      if (this.value.mailTemplate) {
        mailTemplateId = this.value.mailTemplate.templateId;
      } else {
        mailLanguageTemplates = mailTemplate.languageTemplates;
      }

      let cycle = 0;
      let cycleType = 0;
      let scheduledSendAt = "0";
      if (this.form.isSchedledMail) {
        cycleType = this.form.cycleType;
        if (cycleType == 0) {
          if (this.form.scheduledSendAt <= new Date().getTime()) {
            this.$alert("定时时间必须在当前时间之后", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
          scheduledSendAt = String(this.form.scheduledSendAt);
        } else if (cycleType == 1) {
          let cycle1 = Number(this.cycleForm.cycle1);
          let cycle1_1 = Number(this.cycleForm.cycle1_1);
          cycle = cycle1 * 60 + cycle1_1;
        } else if (cycleType == 2) {
          let cycle2 = Number(this.cycleForm.cycle2);
          let cycle2_1 = Number(this.cycleForm.cycle2_1);
          let cycle2_2 = Number(this.cycleForm.cycle2_2);

          cycle = (cycle2 - 1) * 24 * 60 + cycle2_1 * 60 + cycle2_2;
        } else if (cycleType == 3) {
          let cycle3 = Number(this.cycleForm.cycle3);
          let cycle3_1 = Number(this.cycleForm.cycle3_1);
          let cycle3_2 = Number(this.cycleForm.cycle3_2);

          cycle = (cycle3 - 1) * 24 * 60 + cycle3_1 * 60 + cycle3_2;
        }
      }

      let text = "";

      // 是否根据条件指定收件人
      let isSelectPlayersByConditions = false;

      // 根据uid指定收件人时所填的uid集合
      let uidList = [];

      // 根据tid指定收件人时所填的tid集合
      let tidList = [];

      if (this.form.activeReceiversSelectorTabName == "byConditions") {
        isSelectPlayersByConditions = true;
      } else if (this.form.activeReceiversSelectorTabName == "byUids") {
        let parseResult = this.parseUidList();
        if (parseResult.err) {
          this.$message({
            message: parseResult.err,
            type: "error",
          });
          return;
        }

        uidList = parseResult.list;
      } else if (this.form.activeReceiversSelectorTabName == "byTids") {
        let parseResult = this.parseTidList();
        if (parseResult.err) {
          this.$message({
            message: parseResult.err,
            type: "error",
          });
          return;
        }

        tidList = parseResult.list;
      }

      if (isSelectPlayersByConditions) {
        text = "即将发送一封大范围邮件，确定吗？";
        // 必须选择目标分区
        if (this.form.selectedZoneId === "") {
          this.$message({
            message: "请选择目标分区",
            type: "error",
          });
          return;
        }

        selectedZoneId = parseInt(this.form.selectedZoneId);

        // 必须选择目标渠道
        if (this.form.selectedChannelId === "") {
          this.$message({
            message: "请选择目标渠道",
            type: "error",
          });
          return;
        }

        selectedChannelId = parseInt(this.form.selectedChannelId);
      }

      if (this.form.isSchedledMail) {
        text = "即将创建一封定时邮件";
      }

      try {
        if (text.length > 0) {
          await this.$confirm(text, "警告", {
            type: "warning",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          });
        }
      } catch (e) {
        return;
      }

      let startAt = new Date(this.form.startAt).setSeconds(0, 0);
      let endAt = new Date(this.form.endAt).setSeconds(59, 999);

      if (
        this.$bizutil.isAuditedWithOperation() &&
        this.form.remark.trim().length == 0
      ) {
        this.$message({
          message: "请填写备注",
          type: "error",
        });
        return;
      }

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/sendMail`,
          {
            mailTemplateId: mailTemplateId,
            mailLanguageTemplates: mailLanguageTemplates,
            zoneId: selectedZoneId,
            channelId: selectedChannelId,
            isProvideAll: isSelectPlayersByConditions,
            uidList: uidList,
            tidList: tidList,
            props: JSON.stringify(attachments),
            scheduledSendAt: scheduledSendAt,
            cycleType: cycleType,
            cycle: cycle,
            startAt: String(startAt),
            endAt: String(endAt),
            remark: this.form.remark,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
              requestId: this.requestId,
            },
          }
        )
      ).data;

      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      this.$message({
        duration: this.$bizutil.isAuditedWithOperation() ? 0 : 3000,
        showClose: this.$bizutil.isAuditedWithOperation() ? true : false,
        message: this.$bizutil.isAuditedWithOperation()
          ? "已提交申请，待申请通过之后系统将会自动（或定时）发送该邮件。申请结果会通过您的通知地址反馈给您，您也可以在企业投票页面中看到此次申请的进度。"
          : "操作成功",
        type: "success",
      });

      // 关闭当前对话框
      this.visible = false;
    },

    /**
     * 解析uid集合
     *
     * @returns {list: [], err: "xxxx"}
     */
    parseUidList() {
      let list = [];

      let uidListStr = this.form.uidList.trim();
      if (uidListStr.length > 0) {
        let arr = uidListStr.split(/\s+/);
        for (let e of arr) {
          let uid = Number(e);
          if (isNaN(uid) || uid != parseInt(uid)) {
            return {
              list: [],
              err: "uid格式错误",
            };
          }

          if (uid <= 0) {
            return {
              list: [],
              err: "uid必须是正整数",
            };
          }

          list.push(uid);
        }
      }

      if (list.length == 0) {
        return {
          list: [],
          err: "请输入uid",
        };
      }

      return {
        list: list,
      };
    },

    /**
     * 解析tid集合
     *
     * @returns {list: [], err: "xxxx"}
     */
    parseTidList() {
      let list = [];

      let tidListStr = this.form.tidList.trim();
      if (tidListStr.length > 0) {
        let arr = tidListStr.split(/\s+/);
        for (let e of arr) {
          let tid = e.trim();
          if (tid.length == 0) {
            continue;
          }

          list.push(tid);
        }
      }

      if (list.length == 0) {
        return {
          list: [],
          err: "请输入tid",
        };
      }

      return {
        list: list,
      };
    },

    async cycleTypeChange(e) {
      if (e == 0) {
        this.isShowSatrtAndEndAt = false;
      } else {
        this.isShowSatrtAndEndAt = true;
      }
    },
    formatSimpleTime(val) {
      let v = parseInt(val);
      if (v < 10) {
        return "0" + v;
      }
      return v;
    },
    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>


<style lang="scss" scoped></style>